module.exports = __webpack_public_path__ + "static/president-91ba230f6349b78870fa2027d44df3d6.jpg";